import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { handleMediaDownload } from "../../../appStore/actions/ArkchatGroup/action";

const SignedAudioPlayer = ({ location }) => {
  const dispatch = useDispatch();
  const [signedUrl, setSignedUrl] = useState(null);

  useEffect(() => {
    if (!location) return;
    dispatch(handleMediaDownload({ location })).then((res) => {
      if (res?.data) {
        setSignedUrl(res.data);
      }
    });
  }, [location]);

  if (!signedUrl) return null;

  return <audio controls controlsList="nodownload" src={signedUrl} />;
};

export default SignedAudioPlayer;
